import { Page } from "@/models/page-models/Page";

export const CallOff: Page = {
  "path": "calloff-master",
  "name": "Call Off",
  "props": {
    "data": {
      "title": "Call Off",
      "printable": "FALSE",
      "url": "calloff-master",
      "groups": [
        {
          "type": "tabs",
          "tabItems": [
            {
              "tabName": "Pending",
              "bracketValueFormula": "{{fetchedData.pendingCallOffs.data.totalDocs}}",
              "rows": [
                {
                  "name": "1",
                  "pageItems": [
                    {
                      "type": "table",
                      "label": "Pending Calloffs",
                      "disabled": "FALSE",
                      "showIf": "{{fetchedData.pendingCallOffs.data}}",
                      "items": "fetchedData.pendingCallOffs.data.docs",
                      "headers": [
                        {
                          "value": "__item._id",
                          "text": "CallOff #"
                        },
                        {
                          "value": "__item.quotationId",
                          "text": "SO #",
                           "type": "custom-url",
                           "customUrlFns": [
                            {
                              "executionOrder": 1,
                              "pageFunction": {
                                "name": "openQtInNewTab",
                                "type": "fnRedirect",
                                "arg1Key": "redirectUrl",
                                "arg1Value": "/view-sales-contract/{{__item.quotationId}}",
                                "arg2Key": "openNewTab",
                                "arg2Value": "TRUE"
                              },
                              "name": "openQtInNewTab"
                            }
                          ]
                        },
                        {
                          "value": "__item.customerPO",
                          "text": "PO#"
                        },
                        {
                          "value": "__item.customer",
                          "text": "Customer",
                          "formula": "fn(HELPER_FN,customerAlias,{{__item.customer}})"
                        },
                        {
                          "value": "__item.product",
                          "text": "Product",
                          "formula": "fn(HELPER_FN,productAlias,{{__item.product}})"
                        },
                        {
                          "value": "__item.quantity",
                          "text": "Quantity",
                          "type": "formula",
                          "formula": "fn(HELPER_FN,numFormat,{{__item.quantity}})"
                        },
                        {
                          "value": "__item.unit.unit2",
                          "text": "Selling Unit"
                        },
                        {
                          "value": "__item.FOC",
                          "text": "FOC",
                          "type": "formula",
                          "formula": "fn(HELPER_FN,numFormat,{{__item.FOC}})",
                          "showIf": "fn(ARRAY_SUM,{{__item.FOC}},{{fetchedData.pendingCalloffs.data}})"
                        },
                        {
                          "value": "__item.targetDate",
                          "text": "Target Delivery Date",
                          "type": "date",
                          "formula": "fn(HELPER_FN,dateFormat,{{__item.targetDate}})"
                        },
                        {
                          "value": "__item.status",
                          "text": "Status"
                        },
                        {
                          "value": "__item.target",
                          "text": "Target",
                          "formula": "fn(HELPER_FN,orderTarget,{{__item.target}})"
                        }
                      ],
                      "tableType": "static",
                      "showActions": true,
                      "selectableUniqueId": "_id",
                      "groupActions": [
                        {
                          "label": "Add To Target",
                          "onClick": [
                            {
                              "executionOrder": 1,
                              "name": "copySelectedCallOff"
                            },
                            {
                              "executionOrder": 1,
                              "pageFunction": {
                                "name": "copyDefaultTargetForm",
                                "type": "fnCopyData",
                                "arg1Key": "sourceFn",
                                "arg1Value": "getDefaultTargetForm",
                                "arg2Key": "destinationKey",
                                "arg2Value": "formData",
                                "arg3Key": "destinationKeyType",
                                "arg3Value": "Object",
                                "arg4Key": "append",
                                "arg4Value": "TRUE",
                                "arg5Key": "sourceKey",
                                "arg5Value": "__item"
                              },
                              "name": "copyDefaultTargetForm"
                            },
                            {
                              "executionOrder": 2,
                              "pageFunction": {
                                "name": "openAddToTargetPopup",
                                "type": "fnOpenPopup",
                                "arg1Key": "popupName",
                                "arg1Value": "Add To Target"
                              },
                              "name": "openAddToTargetPopup"
                            }
                          ]
                        },
                        {
                          "label": "Mark As Complete",
                          "onClick": [
                            {
                              "executionOrder": 1,
                              "pageFunction": {
                                "name": "markCalloffAsComplete",
                                "type": "fnSubmit",
                                "arg1Key": "apiUrl",
                                "arg1Value": "/api/v1/callOff/{{__item._id}}/mark-completed",
                                "arg2Key": "postData",
                                "arg2Value": "\"{}\"",
                                "arg3Key": "requestMethod",
                                "arg3Value": "PATCH"
                              },
                              "executeIf": "fn(LOGICAL,fn(CONCAT,',{{__item.status}},'),==,'Invoiced')",
                              "name": "markCalloffAsComplete"
                            },
                            {
                              "executionOrder": 1,
                              "pageFunction": {
                                "name": "markPendingCalloffAsComplete",
                                "type": "fnSubmit",
                                "arg1Key": "apiUrl",
                                "arg1Value": "/api/v1/callOff/{{__item._id}}/mark-pending-to-completed",
                                "arg2Key": "postData",
                                "arg2Value": "\"{}\"",
                                "arg3Key": "requestMethod",
                                "arg3Value": "PATCH"
                              },
                              "executeIf": "fn(LOGICAL,fn(CONCAT,',{{__item.status}},'),==,'Pending')",
                              "name": "markCalloffAsComplete"
                            },
                            {
                              "executionOrder": 2,
                              "name": "getPendingCallOffs",
                              "executeOnce": true
                            },
                            {
                              "executionOrder": 2,
                              "name": "getTargetCallOffs",
                              "executeOnce": true
                            }
                          ]
                        },
                        {
                          "label": "Hold",
                          "onClick": [
                            {
                              "executionOrder": 1,
                              "name": "holdCallOff"
                            },
                            {
                              "executionOrder": 2,
                              "name": "getPendingCallOffs",
                              "executeOnce": true
                            },
                            {
                              "executionOrder": 2,
                              "name": "getCallOffsOnHold",
                              "executeOnce": true
                            }
                          ]
                        },
                        {
                          "label": "Cancel",
                          "onClick": [
                            {
                              "executionOrder": 1,
                              "name": "cancelCallOff"
                            },
                            {
                              "executionOrder": 2,
                              "name": "getPendingCallOffs",
                              "executeOnce": true
                            }
                          ]
                        }
                      ],
                      "neverHideActionBar": true,
                      "height": "69vh",
                      "pagination": {
                        "pageVariable": "fetchedData.pendingCallOffsForm.page",
                        "serverItemsLengthVariable": "fetchedData.pendingCallOffs.data.totalDocs",
                        "pageChangeFns": [
                          {
                            "executionOrder": 2,
                            "name": "getPendingCallOffs"
                          }
                        ],
                        "itemsPerPageVariable": "fetchedData.pendingCallOffs.data.limit"
                      }
                    }
                  ]
                }
              ]
            },
            {
              "tabName": "Target",
              "bracketValueFormula": "{{fetchedData.inTargetCallOffs.data.totalDocs}}",
              "rows": [
                {
                  "name": "1",
                  "pageItems": [
                    {
                      "type": "table",
                      "label": "Calloffs in Target",
                      "disabled": "FALSE",
                      "showIf": "{[fetchedData.inTargetCallOffs.data}}",
                      "items": "fetchedData.inTargetCallOffs.data.docs",
                      "headers": [
                        {
                          "value": "__item._id",
                          "text": "CallOff #"
                        },
                        {
                          "value": "__item.quotationId",
                          "text": "SO #",
                           "type": "custom-url",
                           "customUrlFns": [
                            {
                              "executionOrder": 1,
                              "pageFunction": {
                                "name": "openQtInNewTab",
                                "type": "fnRedirect",
                                "arg1Key": "redirectUrl",
                                "arg1Value": "/view-sales-contract/{{__item.quotationId}}",
                                "arg2Key": "openNewTab",
                                "arg2Value": "TRUE"
                              },
                              "name": "openQtInNewTab"
                            }
                          ]
                        },
                        {
                          "value": "__item.customerPO",
                          "text": "PO#"
                        },
                        {
                          "value": "__item.customer",
                          "text": "Customer",
                          "formula": "fn(HELPER_FN,customerAlias,{{__item.customer}})"
                        },
                        {
                          "value": "__item.product",
                          "text": "Product",
                          "formula": "fn(HELPER_FN,productAlias,{{__item.product}})"
                        },
                        {
                          "value": "__item.quantity",
                          "text": "Quantity",
                          "type": "formula",
                          "formula": "fn(HELPER_FN,numFormat,{{__item.quantity}})"
                        },
                        {
                          "value": "__item.unit.unit2",
                          "text": "Selling Unit"
                        },
                        {
                          "value": "__item.FOC",
                          "text": "FOC",
                          "type": "formula",
                          "formula": "fn(HELPER_FN,numFormat,{{__item.FOC}})",
                          "showIf": "fn(ARRAY_SUM,{{__item.FOC}},{{fetchedData.pendingCalloffs.data}})"
                        },
                        {
                          "value": "__item.targetDate",
                          "text": "Target Date",
                          "type": "date",
                          "formula": "fn(HELPER_FN,dateFormat,{{__item.targetDate}})"
                        },
                        {
                          "value": "__item.status",
                          "text": "Status"
                        },
                        {
                          "value": "__item.target",
                          "text": "Target",
                          "formula": "fn(HELPER_FN,orderTarget,{{__item.target}})"
                        }
                      ],
                      "tableType": "static",
                      "showActions": true,
                      "selectableUniqueId": "_id",
                      "groupActions": [
                        {
                          "label": "Add To Target",
                          "onClick": [
                            {
                              "executionOrder": 1,
                              "name": "copySelectedCallOff"
                            },
                            {
                              "executionOrder": 1,
                              "pageFunction": {
                                "name": "copyDefaultTargetForm",
                                "type": "fnCopyData",
                                "arg1Key": "sourceFn",
                                "arg1Value": "getDefaultTargetForm",
                                "arg2Key": "destinationKey",
                                "arg2Value": "formData",
                                "arg3Key": "destinationKeyType",
                                "arg3Value": "Object",
                                "arg4Key": "append",
                                "arg4Value": "TRUE",
                                "arg5Key": "sourceKey",
                                "arg5Value": "__item"
                              },
                              "name": "copyDefaultTargetForm"
                            },
                            {
                              "executionOrder": 2,
                              "pageFunction": {
                                "name": "openAddToTargetPopup",
                                "type": "fnOpenPopup",
                                "arg1Key": "popupName",
                                "arg1Value": "Add To Target"
                              },
                              "name": "openAddToTargetPopup"
                            }
                          ]
                        },
                        {
                          "label": "Mark As Complete",
                          "onClick": [
                            {
                              "executionOrder": 1,
                              "pageFunction": {
                                "name": "markCalloffAsComplete",
                                "type": "fnSubmit",
                                "arg1Key": "apiUrl",
                                "arg1Value": "/api/v1/callOff/{{__item._id}}/mark-completed",
                                "arg2Key": "postData",
                                "arg2Value": "\"{}\"",
                                "arg3Key": "requestMethod",
                                "arg3Value": "PATCH"
                              },
                              "executeIf": "fn(LOGICAL,fn(CONCAT,',{{__item.status}},'),==,'Invoiced')",
                              "name": "markCalloffAsComplete"
                            },
                            {
                              "executionOrder": 1,
                              "pageFunction": {
                                "name": "markPendingCalloffAsComplete",
                                "type": "fnSubmit",
                                "arg1Key": "apiUrl",
                                "arg1Value": "/api/v1/callOff/{{__item._id}}/mark-pending-to-completed",
                                "arg2Key": "postData",
                                "arg2Value": "\"{}\"",
                                "arg3Key": "requestMethod",
                                "arg3Value": "PATCH"
                              },
                              "executeIf": "fn(LOGICAL,fn(CONCAT,',{{__item.status}},'),==,'Pending')",
                              "name": "markCalloffAsComplete"
                            },
                            {
                              "executionOrder": 2,
                              "name": "getPendingCallOffs",
                              "executeOnce": true
                            },
                            {
                              "executionOrder": 2,
                              "name": "getTargetCallOffs",
                              "executeOnce": true
                            }
                          ]
                        },
                        {
                          "label": "Hold",
                          "onClick": [
                            {
                              "executionOrder": 1,
                              "name": "holdCallOff"
                            },
                            {
                              "executionOrder": 2,
                              "name": "getTargetCallOffs",
                              "executeOnce": true
                            },
                            {
                              "executionOrder": 2,
                              "name": "getCallOffsOnHold",
                              "executeOnce": true
                            }
                          ]
                        },
                        {
                          "label": "Cancel",
                          "onClick": [
                            {
                              "executionOrder": 1,
                              "name": "cancelCallOff"
                            },
                            {
                              "executionOrder": 2,
                              "name": "getTargetCallOffs",
                              "executeOnce": true
                            }
                          ]
                        }
                      ],
                      "neverHideActionBar": true,
                      "height": "69vh",
                      "pagination": {
                        "pageVariable": "fetchedData.inTargetCallOffsForm.page",
                        "serverItemsLengthVariable": "fetchedData.inTargetCallOffs.data.totalDocs",
                        "pageChangeFns": [
                          {
                            "executionOrder": 2,
                            "name": "getTargetCallOffs"
                          }
                        ],
                        "itemsPerPageVariable": "fetchedData.inTargetCallOffs.data.limit"
                      }
                    }
                  ]
                }
              ]
            },
            {
              "tabName": "On Hold",
              "bracketValueFormula": "{{fetchedData.callOffsOnHold.data.totalDocs}}",
              "rows": [
                {
                  "name": "1",
                  "pageItems": [
                    {
                      "type": "table",
                      "label": "Calloffs On Hold",
                      "disabled": "FALSE",
                      "showIf": "{{fetchedData.callOffsOnHold.data}}",
                      "items": "fetchedData.callOffsOnHold.data.docs",
                      "headers": [
                        {
                          "value": "__item._id",
                          "text": "CallOff #"
                        },
                        {
                          "value": "__item.quotationId",
                          "text": "SO #",
                           "type": "custom-url",
                           "customUrlFns": [
                            {
                              "executionOrder": 1,
                              "pageFunction": {
                                "name": "openQtInNewTab",
                                "type": "fnRedirect",
                                "arg1Key": "redirectUrl",
                                "arg1Value": "/view-sales-contract/{{__item.quotationId}}",
                                "arg2Key": "openNewTab",
                                "arg2Value": "TRUE"
                              },
                              "name": "openQtInNewTab"
                            }
                          ]
                        },
                        {
                          "value": "__item.customerPO",
                          "text": "PO#"
                        },
                        {
                          "value": "__item.customer",
                          "text": "Customer",
                          "formula": "fn(HELPER_FN,customerAlias,{{__item.customer}})"
                        },
                        {
                          "value": "__item.product",
                          "text": "Product",
                          "formula": "fn(HELPER_FN,productAlias,{{__item.product}})"
                        },
                        {
                          "value": "__item.quantity",
                          "text": "Quantity",
                          "type": "formula",
                          "formula": "fn(HELPER_FN,numFormat,{{__item.quantity}})"
                        },
                        {
                          "value": "__item.unit.unit2",
                          "text": "Selling Unit"
                        },
                        {
                          "value": "__item.FOC",
                          "text": "FOC",
                          "type": "formula",
                          "formula": "fn(HELPER_FN,numFormat,{{__item.FOC}})",
                          "showIf": "fn(ARRAY_SUM,{{__item.FOC}},{{fetchedData.pendingCalloffs.data}})"
                        },
                        {
                          "value": "__item.targetDate",
                          "text": "Target Date",
                          "type": "date",
                          "formula": "fn(HELPER_FN,dateFormat,{{__item.targetDate}})"
                        },
                        {
                          "value": "__item.status",
                          "text": "Status"
                        },
                        {
                          "value": "__item.target",
                          "text": "Target",
                          "formula": "fn(HELPER_FN,orderTarget,{{__item.target}})"
                        }
                      ],
                      "tableType": "static",
                      "showActions": true,
                      "selectableUniqueId": "_id",
                      "groupActions": [
                        {
                          "label": "Unhold",
                          "onClick": [
                            {
                              "executionOrder": 1,
                              "name": "unHoldCallOff"
                            },
                            {
                              "executionOrder": 2,
                              "name": "getPendingCallOffs",
                              "executeOnce": true
                            },
                            {
                              "executionOrder": 2,
                              "name": "getTargetCallOffs",
                              "executeOnce": true
                            },
                            {
                              "executionOrder": 2,
                              "name": "getCallOffsOnHold",
                              "executeOnce": true
                            }
                          ]
                        }
                      ],
                      "neverHideActionBar": true,
                      "height": "69vh",
                      "pagination": {
                        "pageVariable": "fetchedData.callOffsOnHoldForm.page",
                        "serverItemsLengthVariable": "fetchedData.callOffsOnHold.data.totalDocs",
                        "pageChangeFns": [
                          {
                            "executionOrder": 2,
                            "name": "getCallOffsOnHold"
                          }
                        ],
                        "itemsPerPageVariable": "fetchedData.callOffsOnHold.data.limit"
                      }
                    }
                  ]
                }
              ]
            },
            {
              "tabName": "Complete",
              "bracketValueFormula": "{{fetchedData.completeCallOffs.data.totalDocs}}",
              "rows": [
                {
                  "name": "1",
                  "pageItems": [
                    {
                      "type": "table",
                      "label": "Completed Calloffs",
                      "disabled": "FALSE",
                      "showIf": "{{fetchedData.completeCallOffs.data}}",
                      "items": "fetchedData.completeCallOffs.data.docs",
                      "headers": [
                        {
                          "value": "__item._id",
                          "text": "CallOff #"
                        },
                        {
                          "value": "__item.quotationId",
                          "text": "SO #",
                           "type": "custom-url",
                           "customUrlFns": [
                            {
                              "executionOrder": 1,
                              "pageFunction": {
                                "name": "openQtInNewTab",
                                "type": "fnRedirect",
                                "arg1Key": "redirectUrl",
                                "arg1Value": "/view-sales-contract/{{__item.quotationId}}",
                                "arg2Key": "openNewTab",
                                "arg2Value": "TRUE"
                              },
                              "name": "openQtInNewTab"
                            }
                          ]
                        },
                        {
                          "value": "__item.customerPO",
                          "text": "PO#"
                        },
                        {
                          "value": "__item.customer",
                          "text": "Customer",
                          "formula": "fn(HELPER_FN,customerAlias,{{__item.customer}})"
                        },
                        {
                          "value": "__item.product",
                          "text": "Product",
                          "formula": "fn(HELPER_FN,productAlias,{{__item.product}})"
                        },
                        {
                          "value": "__item.quantity",
                          "text": "Quantity",
                          "type": "formula",
                          "formula": "fn(HELPER_FN,numFormat,{{__item.quantity}})"
                        },
                        {
                          "value": "__item.unit.unit2",
                          "text": "Selling Unit"
                        },
                        {
                          "value": "__item.FOC",
                          "text": "FOC",
                          "type": "formula",
                          "formula": "fn(HELPER_FN,numFormat,{{__item.FOC}})",
                          "showIf": "fn(ARRAY_SUM,{{__item.FOC}},{{fetchedData.pendingCalloffs.data}})"
                        },
                        {
                          "value": "__item.targetDate",
                          "text": "Target Date",
                          "type": "date",
                          "formula": "fn(HELPER_FN,dateFormat,{{__item.targetDate}})"
                        },
                        {
                          "value": "__item.status",
                          "text": "Status"
                        },
                        {
                          "value": "__item.target",
                          "text": "Target",
                          "formula": "fn(HELPER_FN,orderTarget,{{__item.target}})"
                        }
                      ],
                      "tableType": "static",
                      "showActions": true,
                      "neverHideActionBar": true,
                      "height": "69vh",
                      "pagination": {
                        "pageVariable": "fetchedData.completeCallOffForm.page",
                        "serverItemsLengthVariable": "fetchedData.completeCallOffs.data.totalDocs",
                        "pageChangeFns": [
                          {
                            "executionOrder": 2,
                            "name": "getCompleteCallOffs"
                          }
                        ],
                        "itemsPerPageVariable": "fetchedData.completeCallOffs.data.limit"
                      }
                    }
                  ]
                }
              ]
            }
          ]
        },
        {
          "type": "popupGroup",
          "label": "Add To Target",
          "popupItems": [
            {
              "name": "1",
              "pageItems": [
                {
                  "type": "input",
                  "variable": "formData.quantity",
                  "label": "Target Quantity",
                  "disabled": "FALSE",
                  "unit": "{{fetchedData.selectedCallOff.product.packingMode.0.unit1}}"
                },
                {
                  "type": "datepicker",
                  "variable": "formData.month",
                  "label": "Month",
                  "disabled": "FALSE",
                  "minDateFormula": "{{MONTH_START}}",
                  "maxDateFormula": "{{MONTH_END}}",
                  "showWeekNumber": true
                }
              ]
            }
          ],
          "popupActions": [
            {
              "label": "Add To Target",
              "onClick": [
                {
                  "executionOrder": 1,
                  "pageFunction": {
                    "name": "addToTarget",
                    "type": "fnSubmit",
                    "arg1Key": "apiUrl",
                    "arg1Value": "/api/v1/callOff/{{fetchedData.selectedCallOff._id}}/add-to-target",
                    "arg2Key": "postData",
                    "arg2Value": "formData",
                    "arg3Key": "refreshPage",
                    "arg3Value": "TRUE"
                  },
                  "name": "addToTarget"
                },
                {
                  "executionOrder": 2,
                  "pageFunction": {
                    "name": "closeTargetPopup",
                    "type": "fnClosePopup",
                    "arg1Key": "popupName",
                    "arg1Value": "Add To Target"
                  },
                  "name": "closeTargetPopup"
                }
              ]
            }
          ],
          "width": "500"
        }
      ],
      "useMaxPageWidth": true
    },
    "initialFunctionsCalled": [
      {
        "executionOrder": 1,
        "name": "copyPendingCallOffsForm"
      },
      {
        "executionOrder": 2,
        "name": "getPendingCallOffs"
      },
      {
        "executionOrder": 1,
        "name": "copyTargetCallOffsForm"
      },
      {
        "executionOrder": 2,
        "name": "getTargetCallOffs"
      },
      {
        "executionOrder": 1,
        "name": "copyCallOffsOnHoldForm",
      },
      {
        "executionOrder": 2,
        "name": "getCallOffsOnHold"
      },
      {
        "executionOrder": 1,
        "name": "copyCompleteCallOffForm"
      },
      {
        "executionOrder": 2,
        "name": "getCompleteCallOffs"
      }
    ],
    "functions": [
      {
        "name": "getPendingCallOffs",
        "type": "fnGetData",
        "arg1Key": "apiUrl",
        "arg1Value": "/api/v1/callOff/search",
        "arg2Key": "storeInVar",
        "arg2Value": "fetchedData.pendingCallOffs",
        "arg3Key": "postData",
        "arg3Value": "fetchedData.pendingCallOffsForm"
      },
      {
        "name": "getTargetCallOffs",
        "type": "fnGetData",
        "arg1Key": "apiUrl",
        "arg1Value": "/api/v1/callOff/search",
        "arg2Key": "storeInVar",
        "arg2Value": "fetchedData.inTargetCallOffs",
        "arg3Key": "postData",
        "arg3Value": "fetchedData.inTargetCallOffsForm"
      },
      {
        "name": "getCallOffsOnHold",
        "type": "fnGetData",
        "arg1Key": "apiUrl",
        "arg1Value": "/api/v1/callOff/search",
        "arg2Key": "storeInVar",
        "arg2Value": "fetchedData.callOffsOnHold",
        "arg3Key": "postData",
        "arg3Value": "fetchedData.callOffsOnHoldForm"
      },
      {
        "name": "getCompleteCallOffs",
        "type": "fnGetData",
        "arg1Key": "apiUrl",
        "arg1Value": "/api/v1/callOff/search",
        "arg2Key": "storeInVar",
        "arg2Value": "fetchedData.completeCallOffs",
        "arg3Key": "postData",
        "arg3Value": "fetchedData.completeCallOffForm"
      },
      {
        "name": "holdCallOff",
        "type": "fnSubmit",
        "arg1Key": "apiUrl",
        "arg1Value": "/api/v1/callOff/{{__item._id}}/holdCallOff",
        "arg2Key": "postData",
        "arg2Value": "\"{}\"",
        "arg3Key": "requestMethod",
        "arg3Value": "PATCH"
      },
      {
        "name": "unHoldCallOff",
        "type": "fnSubmit",
        "arg1Key": "apiUrl",
        "arg1Value": "/api/v1/callOff/{{__item._id}}/unHoldCallOff",
        "arg2Key": "postData",
        "arg2Value": "\"{}\"",
        "arg3Key": "requestMethod",
        "arg3Value": "PATCH"
      },
      {
        "name": "cancelCallOff",
        "type": "fnSubmit",
        "arg1Key": "apiUrl",
        "arg1Value": "/api/v1/callOff/{{__item._id}}/mark-cancelled",
        "arg2Key": "postData",
        "arg2Value": "\"{}\"",
        "arg3Key": "requestMethod",
        "arg3Value": "PATCH"
      },
      {
        "name": "copyPendingCallOffsForm",
        "type": "fnCopyData",
        "arg1Key": "sourceFn",
        "arg1Value": "getPendingCallOffsForm",
        "arg2Key": "destinationKey",
        "arg2Value": "fetchedData.pendingCallOffsForm",
        "arg4Key": "destinationKeyType",
        "arg4Value": "Object"
      },
      { 
        "name": "getPendingCallOffsForm",
        "type": "fnCreateObjectFromKeys",
        "newKeyValues": {
          "page": 1,
          "limit": 50,
          "q": {
            "status": ["Invoiced","Pending"],
            "inTarget": "false"
          }
        },
        "staticObject": true
      },
      {
        "name": "copyTargetCallOffsForm",
        "type": "fnCopyData",
        "arg1Key": "sourceFn",
        "arg1Value": "getTargetCallOffsForm",
        "arg2Key": "destinationKey",
        "arg2Value": "fetchedData.inTargetCallOffsForm",
        "arg4Key": "destinationKeyType",
        "arg4Value": "Object"
      },
      { 
        "name": "getTargetCallOffsForm",
        "type": "fnCreateObjectFromKeys",
        "newKeyValues": {
          "page": 1,
          "limit": 50,
          "q": {
            "status": ["Invoiced","Pending"],
            "inTarget": "true"
          }
        },
        "staticObject": true
      },
      {
        "name": "copyCallOffsOnHoldForm",
        "type": "fnCopyData",
        "arg1Key": "sourceFn",
        "arg1Value": "getCallOffsOnHoldForm",
        "arg2Key": "destinationKey",
        "arg2Value": "fetchedData.callOffsOnHoldForm",
        "arg4Key": "destinationKeyType",
        "arg4Value": "Object"
      },
      { 
        "name": "getCallOffsOnHoldForm",
        "type": "fnCreateObjectFromKeys",
        "newKeyValues": {
          "page": 1,
          "limit": 50,
          "q": {
            "status": ["Hold"]
          }
        },
        "staticObject": true
      },
      {
        "name": "copyCompleteCallOffForm",
        "type": "fnCopyData",
        "arg1Key": "sourceFn",
        "arg1Value": "getCompleteCallOffForm",
        "arg2Key": "destinationKey",
        "arg2Value": "fetchedData.completeCallOffForm",
        "arg4Key": "destinationKeyType",
        "arg4Value": "Object"
      },
      { 
        "name": "getCompleteCallOffForm",
        "type": "fnCreateObjectFromKeys",
        "newKeyValues": {
          "page": 1,
          "limit": 50,
          "q": {
            "status": ["Complete"]
          }
        },
        "staticObject": true
      },
      {
        "name": "copySelectedCallOff",
        "type": "fnCopyData",
        "arg1Key": "sourceKey",
        "arg1Value": "__item",
        "arg2Key": "destinationKey",
        "arg2Value": "fetchedData.selectedCallOff"
      },
      { 
        "name": "getDefaultTargetForm",
        "type": "fnCreateObjectFromKeys",
        "newKeyValues": {
          "quantity": "fn(HELPER_FN,orderQuantityInBaseUnit,{{fetchedData.selectedCallOff}})",
          "month": "fn(HELPER_FN,dateFormat,{{MONTH_END}},date-picker)"
        },
        "useFormula": true
      }
    ]
  },
  "forRole": "CUSTOMER_SERVICE_MANAGER",
  "visible": true,
  "routerPriority": 100
}